<script setup lang="ts">
import type { FilterOption } from '~/components/SelectFilter.vue';

const props = defineProps<{
	row: any,
}>()

const emit = defineEmits<{
	update: []
}>()

const { confirm_modal_show } = useConfirmModal()
const { t } = useI18n()
const api = useApi()
const toast = useToast()

const statuses: FilterOption[] = [
	{ key: 'ax_in_progress', label: t('ax_in_progress'), color: "yellow" },
	{ key: 'new', label: t('new'), color: "blue" },
	{ key: 'completed', label: t('completed'), color: "green" },
	{ key: 'new_error', label: t('manual_processing'), color: "orange" },
]
const getDataFromObj = (arr: FilterOption[], searchVal: string) => arr.find(el => el.key === searchVal)

async function show_confirm_dialog__cs_topup_order_restart(order: any) {
	if (order.status != 'new_error') {
		return
	}
	
	const result = await confirm_modal_show({
		title: t('restart-order'),
		text: t('are-you-sure-restart-order'),
	})


	if (result) {

		try {

			const response = await api.post('/api/cs_topup_orders/restart', {
				_id: order._id,
			}) as { success: boolean; message?: string }

			if (response.success) {
				emit('update')
			} else {
				toast.add({
					title: t('error'),
					description: response.message,
					color: 'red',
					timeout: 2000,
				})
			}

		} catch (error) {
			console.error('s_topup_order_restart', error)
			toast.add({
				title: t('error'),
				description: `${error}`,
				color: 'red',
				timeout: 2000,
			})
		}
	} else {
		console.log('Операция отменена')
	}
}
</script>

<template>
	<div class="flex flex-col gap-1 items-center">
		<UBadge
			:color="getDataFromObj(statuses, row.status)?.color || 'gray'"
			:label="getDataFromObj(statuses, row.status)?.label || '-'"
			variant="solid"
			class="cursor-pointer"
			@click="show_confirm_dialog__cs_topup_order_restart(row)"
		/>
	</div>
</template>
